// extracted by mini-css-extract-plugin
export default {"wrapper":"Marquee_wrapper__evyPv","track":"Marquee_track__Ixi9T","slide":"Marquee_slide__LXVhO","item":"Marquee_item__NWzvL","dot":"Marquee_dot__5HDGl"};